var render = function render(){var _vm=this,_c=_vm._self._c;return _c('quill-editor',{attrs:{"options":_vm.quillOptions},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}})
}
var staticRenderFns = []

export { render, staticRenderFns }